module.exports = __webpack_public_path__ + "static/img/s03.27e4f296.png";